import React from "react";
import { connect } from "react-redux";
import {
  saveDesign,
  displayShare,
  displayInvalidDialog,
  displayLoginPrompt
} from "../../actions";
import { bindActionCreators } from "redux";
import Logo from "../../components/Layout/Header/Logo";
import ToolButton from "../../components/Layout/Sidebar/ToolButton";
import MobileToolCarousel from "../../components/Layout/Sidebar/MobileToolCarousel";
import ShareButton from "../../components/Layout/Sidebar/ShareButton";
import SaveButton from "../../components/Layout/Sidebar/SaveButton";
import "./SidebarContainer.css";

class SidebarContainer extends React.Component {
  onSaveDesign = () => {
    // Check if elements are within printable area. If they are go ahead and save, otherwise display a warning dialog
    if (this.props.design.numInvalidElements > 0) {
      this.props.displayInvalidDialog({ active: true });
    } else {
      this.props.displayInvalidDialog({ active: false });
      this.handleSaveDesign();
    }
  };

  handleSaveDesign = () => {
    if (this.props.user.loggedIn) {
      this.props.saveDesign({ savedByCustomer: true });
    } else {
      this.handlePromptLogin();
    }
  };

  handlePromptLogin = () => {
    this.props.displayLoginPrompt(true);
  };

  handleDisplayShare = () => {
    this.props.displayShare();
  };

  render() {
    const allowImages = this.props.design.layer_set.filter((layer) => {
      return layer.allow_image === true;
    }).length;
    const allowPhotoImages = this.props.design.layer_set.filter((layer) => {
      return layer.photo_image === true;
    }).length;

    let toolsArray = [
      { id: "style", label: "Style" },
      { id: "color", label: "Color" },
      { id: "text", label: "Text" }
    ];
    const selectedTool = this.props.activeToolCollection;

    if (allowImages || allowPhotoImages) {
      toolsArray.push({ id: "graphics", label: "Graphics" });
      if (allowPhotoImages) {
        toolsArray.push({
          id: "photos",
          label: "Upload Photos/Full Color Art"
        });
      }
      if (allowImages) {
        toolsArray.push({ id: "upload", label: "Upload Graphics" });
      }
    }
    toolsArray.push(
      { id: "align", label: "Align" },
      { id: "info", label: "Product Info" }
    );

    const toolsList = toolsArray.map((tool) => {
      return (
        <ToolButton
          name={tool.label}
          id={tool.id}
          key={tool.id}
          activeTool={this.props.activeToolCollection}
          design={this.props.design}
          routeId={this.props.routeId}
          location={this.props.location}
        />
      );
    });

    if (this.props.user.loggedIn && this.props.user.isAdmin) {
      toolsArray.push({ id: "admin", label: "Admin" });
      toolsList.push(
        <ToolButton
          name="Admin"
          key="Admin"
          id="admin"
          activeTool={this.props.activeToolCollection}
          design={this.props.design}
          routeId={this.props.routeId}
          location={this.props.location}
        />
      );
    }

    return (
      <div className="navigation-container">
        <ul className="navigation">
          <li className="navigation__item navigation__item--logo">
            <Logo />
          </li>

          {toolsList}
        </ul>

        {/* Mobile Tool Carousel */}
        <MobileToolCarousel
          tools={toolsArray}
          activeTool={this.props.activeToolCollection}
          routeId={this.props.routeId}
          design={this.props.design}
          location={this.props.location}
          toggleTools={this.props.toggleTools}
        />

        <ShareButton handleDisplayShare={this.handleDisplayShare} />

        <SaveButton
          onSaveDesign={this.onSaveDesign}
          designVersion={this.props.design.version}
          savedVersion={this.props.dirtyDesign.savedVersion}
          isSaving={this.props.isSaving}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeToolCollection: state.activeToolCollection,
    design: state.design.present,
    dirtyDesign: state.dirtyDesign,
    isSaving: state.design.present.isSaving,
    user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveDesign: saveDesign.request,
      displayShare,
      displayInvalidDialog,
      displayLoginPrompt
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SidebarContainer);
